module.exports = __webpack_public_path__ + "static/media/tado-logo.83d37437.png";